import React, { useState, useEffect, useRef } from "react"
import { imgPlaceholderData } from "@/constants"
import closeIcon from "@/public/icons/close.svg"

const ImageTile = ({ altText = "", url = "", smartCrop = {} }) => {
  const [showModal, setShowModal] = useState(false)
  const favImage = useRef(null)
  const imgPlaceholder = imgPlaceholderData
  const isScene7Img = url.includes("scene7")

  const openModal = () => {
    setShowModal(true)
    document.body.classList.add("modal-open")
  }
  const closeModal = () => {
    setShowModal(false)
    document.body.classList.remove("modal-open")
  }

  useEffect(() => {
    if (smartCrop.scriptStatus && isScene7Img) {
      smartCrop.applySmartCrop(favImage.current)
    }
  }, [smartCrop.scriptStatus])

  return (
    <>
      <div className="image-tile" role="link" tabIndex="0" aria-label={altText}>
        {isScene7Img ? (
          <img
            ref={favImage}
            src={imgPlaceholder}
            data-src={url}
            alt={altText}
            onClick={() => openModal()}
          />
        ) : (
          <img src={url} alt={altText} onClick={() => openModal()} />
        )}
      </div>

      {showModal && (
        <div className="favorites-lightbox">
          <div className="favorites-lightbox__modal">
            <div className="favorites-lightbox__close">
              <img
                src={closeIcon?.src}
                alt="close"
                onClick={() => closeModal()}
              />
            </div>
            <div className="favorites-lightbox__modal__scroll">
              <img
                src={url}
                alt={altText}
                className="favorites-lightbox__modal-img"
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ImageTile
